export const ErrorCodes = {
  UNPROCESSABLE_ERROR: "UNPROCESSABLE_ERROR",
  INVALID_TOKEN: "INVALID_TOKEN",
  RESEND_LIMIT_EXCEED: "RESEND_LIMIT_EXCEED",
  EMAIL_ALREADY_VERIFIED: "EMAIL_ALREADY_VERIFIED",
  BAD_REQUEST_ERROR: "BAD_REQUEST_ERROR",
  VERIFICATION_LINK_EXPIRED: "VERIFICATION_LINK_EXPIRED",
  FORBIDDEN_ERROR: "FORBIDDEN_ERROR",
  EMAIL_NOT_VERIFIED: "EMAIL_NOT_VERIFIED",
  EMAIL_INVALID: "EMAIL_INVALID",
  RESEND_CODE_60_SEC: "RESEND_CODE_60_SEC",
  MAX_ACTIVE_STREAM_INVITES: "MAX_ACTIVE_STREAM_INVITES",
};

export const AttachmentErrors = {
  image: {
    INVALID_FORMAT: "INVALID_IMG_FORMAT",
    ATTACHMENT_TOO_LARGE: "ATTACHMENT_IMG_TOO_LARGE",
    TOO_MANY_FILES: "TOO_MANY_FILES",
  },
  video: {
    INVALID_FORMAT: "INVALID_VIDEO_FORMAT",
    ATTACHMENT_TOO_LARGE: "ATTACHMENT_VIDEO_TOO_LARGE",
    TOO_MANY_FILES: "TOO_MANY_FILES",
  },
  audio: {
    INVALID_FORMAT: "INVALID_AUDIO_FORMAT",
    ATTACHMENT_TOO_LARGE: "ATTACHMENT_AUDIO_TOO_LARGE",
    TOO_MANY_FILES: "TOO_MANY_FILES",
  },
};

export const SubscriptionAttachmentErrors = {
  image: {
    INVALID_FORMAT: "INVALID_IMG_FORMAT",
    ATTACHMENT_TOO_LARGE: "SUBSCRIPTION_ATTACHMENT_IMG_TOO_LARGE",
  },
};

export const multipleSubmissionError = "BE-139";

export const addCardErrors = {
  [multipleSubmissionError]: "ADD_CARD.MULTIPLE_SUBMISSION",
};
